import { Button, Modal } from "rsuite";
import styles from "./ConfirmationModal.module.css";
import { useConfirmationModal } from "./useConfirmationModal";

function ConfirmationModal() {
  const { display, closeModal, actionName, actionFn } = useConfirmationModal();

  let confirmButtonTitle = "Confirm";
  let confirmTitle = "Confirm action";
  if (actionName === "confirmStatusChange")
    confirmTitle = "Please Confirm change of PO status";
  if (actionName === "approveInvoice")
    confirmTitle = "Please confirm document Approval";

  if (actionName === "cancelInvoice")
    confirmTitle = "Please Confirm Cancellation";

  if (actionName === "deleteInvoice") confirmTitle = "Please confirm Deletion";

  if (actionName === "deactivateJob") confirmTitle = "Confirm Job Deactivation";

  if (actionName === "notApproveByOffice")
    confirmTitle = "Please Confirm status change";

  if (actionName === "accessForbidden") confirmTitle = "Access Forbidden";

  const approveAction = () => {
    confirmButtonTitle = "Approve Document";

    return (
      <>
        <p></p>
        <p></p>
        <p>
          <strong>
            By clicking 'Approve', I confirm that I have reviewed and approved
            the document details.
          </strong>
        </p>
        <p></p>
        <p></p>
      </>
    );
  };

  const cancelInvoiceAction = () => {
    confirmButtonTitle = "Cancel Document";
    return (
      <>
        <p></p>
        <p></p>
        <p>
          By clicking 'Cancel Invoice', I confirm that I want to cancel this
          invoice.
        </p>
        <p></p>
        <p></p>
      </>
    );
  };

  return (
    <>
      <Modal size="xs" open={display} onClose={closeModal}>
        <Modal.Header>
          <Modal.Title>{confirmTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {actionName === "approveInvoice" && approveAction()}
          {actionName == "cancelInvoice" && cancelInvoiceAction()}
          {actionName == "deleteInvoice" &&
            "Are you sure you want to delete this invoice ?"}
          {actionName == "cancel" &&
            "Are you sure you want to cancel this order ?"}
          {actionName == "reject" &&
            "Are you sure you want to reject this order ?"}
          {actionName == "notApproveByOffice" && (
            <div>
              This action will reset vendors inquiry status to 'Not inquired'.
            </div>
          )}
          {actionName == "cancelexit" && (
            <div>
              <div>
                Are you sure you want to close this form? Any unsaved changes
                will be lost.
              </div>
            </div>
          )}
          {actionName == "vendorapprove" && (
            <div>
              <div>
                There are unsaved changes that will be lost. Do you want to
                proceed to vendor approval?
              </div>
            </div>
          )}
          {actionName == "deactivateJob" && (
            <div>
              <p>
                <strong>Are you sure you want to deactivate this job?</strong>
              </p>
              <p></p>
              <p>
                This action will lead to cancelling all active work orders on
                the vessel after the next update.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              actionFn();
              closeModal();
            }}
            color="blue"
            appearance="primary"
          >
            {confirmButtonTitle}
          </Button>
          <Button onClick={closeModal} appearance="subtle">
            Return to form
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmationModal;
